var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.811,
    height: 26.364,
    viewBox: "0 0 21.811 26.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-notifications-none",
    "data-name": "Icon material-notifications-none",
    d: "M16.406,29.114a2.609,2.609,0,0,0,2.6-2.6H13.8A2.609,2.609,0,0,0,16.406,29.114Zm7.8-7.8v-6.5c0-3.993-2.12-7.336-5.853-8.22V5.7a1.951,1.951,0,1,0-3.9,0v.884C10.735,7.47,8.6,10.8,8.6,14.806v6.5L6,23.911v1.3H26.811v-1.3Zm-2.6,1.3H11.2v-7.8c0-3.226,1.964-5.853,5.2-5.853s5.2,2.627,5.2,5.853Z",
    transform: "translate(-5.5 -3.25)",
    fill: "#4c2664",
    stroke: "#f3f3f3",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.a421258f1b134bb980b08479a615b734.svg";
export { ForwardRef as ReactComponent };